import { Brand } from 'effect';

export type Percentage = Brand.Branded<number, 'percentage'>;
export namespace Percentage {
    export const make = Brand.nominal<Percentage>();

    export function fromFraction(amount: number, total: number): Percentage {
        if (total === 0) return Percentage.fromNumber(0);
        return Percentage.fromNumber(amount / total);
    }

    /** @param number A value that gets converted to a percentage by multiplying it by `100` */
    export function fromNumber(number: number): Percentage {
        return Percentage.make(number * 100);
    }
}
